import { useEffect, useState } from 'react';
import useRetrieveDevices from '../../common/hooks/useRetrieveDevices';
import LocaleKeys from '../../locales/keys';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DevicesList from '../components/devices/DevicesList';
import ErrorScreen from '../../common/errorScreen';

const useStyles = makeStyles(() => ({
  ascendonDevicesHeader: {
    padding: '10px 0 20px 0',
    textTransform: 'uppercase',
  },
  divider: {
    border: '1px solid #d0d0d2',
  },
  panelHeading: {
    padding: '10px 0 0 0',
    margin: '20px 0',
  },
  semiBold: {
    fontFamily: 'titillium-semibold',
    WebkitFontSmoothing: 'auto',
  },
}));

const Devices = (props) => {
  const { showDevicesContainer } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const [
    RetrieveDevicesResponse,
    RetrieveDevicesFault,
    requestRetrieveDevices,
  ] = useRetrieveDevices();

  const [error, setError] = useState([]);
  const [isMountedState, setIsMountedState] = useState(true);

  useEffect(() => {
    isMountedState && showDevicesContainer && requestRetrieveDevices();

    return () => {
      setIsMountedState(false);
    };
  }, [showDevicesContainer]);

  useEffect(() => {
    if (RetrieveDevicesFault && RetrieveDevicesFault.length) {
      setError(RetrieveDevicesFault);
    }
  }, [RetrieveDevicesFault]);

  return (
    showDevicesContainer && (
      <>
        <Box className="devices panel-default">
          <Box className={`panel-heading ${classes.panelHeading}`}>
            <Typography variant="h2" className={classes.ascendonDevicesHeader}>
              {t(LocaleKeys.subscriptionInfo.devices.devicesHeader)}
            </Typography>
            <Divider />
          </Box>
          {error && error.length ? (
            <ErrorScreen
              hideBackdrop={true}
              error={error}
              mt={5}
              mb={5}
              variant="body1"
            />
          ) : (
            <Box>
              <Typography data-testid="devicesSubHeader" variant="body1">
                <span>
                  {t(LocaleKeys.subscriptionInfo.devices.deviceSubHeaderPrefix)}
                </span>
                <span className={classes.semiBold}>
                  {t(LocaleKeys.subscriptionInfo.devices.deviceSubHeader)}
                </span>
                <span>
                  {t(LocaleKeys.subscriptionInfo.devices.deviceSubHeaderSuffix)}
                </span>
              </Typography>

              {!!RetrieveDevicesResponse && (
                <DevicesList
                  RetrieveDevicesResponse={RetrieveDevicesResponse}
                />
              )}
            </Box>
          )}
        </Box>
      </>
    )
  );
};

export default Devices;
